(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracWebContent', NasracWebContent);

    NasracWebContent.$inject = ['$resource', 'DateUtils'];

    function NasracWebContent ($resource, DateUtils) {
        var resourceUrl =  'api/nasrac-web-contents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.last_modified_time = DateUtils.convertDateTimeFromServer(data.last_modified_time);
                    }
                    return data;
                }
            },
            'getAll':{
                method:'GET',
                url:'/api/nasrac-web-contents/',
                isArray: true
            },
            'getPage': {
                method: 'GET',
                url: '/api/nasrac-web-contents/page/:page',
                isArray: true
            },

            'update': { method:'PUT' }
        });
    }
})();
